import { combineReducers } from '@reduxjs/toolkit';
import { GlobalRouter } from '@okapi/router-react';
import { createReducer as createRouterReducer } from '@okapi/router-connect';
import { featuresReducer } from 'features';
import { Layers } from 'store/utils';
import { initReducer } from './utils/init-reducer';
import { Env } from './types';

export const rootReducer = ({
  cookie,
  env,
  globalRouter,
  host,
  layers,
  userAgent,
  uuid,
  isBot = false,
}: {
  cookie: string;
  env: Env;
  globalRouter: GlobalRouter;
  host: string | null;
  layers: Layers;
  uuid: string;
  userAgent: string | null;
  isBot?: boolean;
}) =>
  combineReducers({
    app: featuresReducer,
    cookie: initReducer(cookie),
    env: initReducer(env),
    host: initReducer(host),
    layers: initReducer(layers),
    router: createRouterReducer(globalRouter),
    userAgent: initReducer(userAgent),
    isBot: initReducer(isBot),
    uuid: initReducer(uuid),
  });

export type RootReducer = ReturnType<ReturnType<typeof rootReducer>>;
